module.exports = __webpack_public_path__ + "img/frame (235).e312293e.jpg";